



























import Vue from 'vue'
import { InfoMessageInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'InfoMessageEl',

  computed: {
    background (): string {
      switch (this.$props.templateItemData.flavour) {
        case 'dark':
          return 'main--display--dark'
        case 'blue':
          return 'main--display--blue'
        default:
          return 'main--display--lite'
      }
    }
  },

  props: {
    templateItemData: {
      type: Object as () => InfoMessageInterface,
      required: true
    }
  }
})
